import {
  ToggleInlineStyle
} from './inline-style'

export class Italic extends ToggleInlineStyle {
  getInlineStyle = () => 'ITALIC'

  getButtonText = () => 'I'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/inline-style/italic.js
 **/